import { get, some } from 'lodash';

class PackageTypes {
  static NON_COMMERCIAL = new PackageTypes(1);
  static BASE = new PackageTypes(2);
  static PROFI = new PackageTypes(3);
  static BUILDER = new PackageTypes(5);
  constructor(id) {
    Object.assign(this, { id });
  }
}

export default [
  '$rootScope',
  '$q',
  '$timeout',
  'apiService',
  ($rootScope, $q, $timeout, apiService) => {
    const svc = {
      isAuthenticated: false,
      verifiedPhoneNumberInCurrentSession: false,
      user: undefined,
      enableAdvertiseMyObject: false,
    };

    let pollingTimeout;

    const POLLING_TIMEOUT = 2 * 1000;

    const setIsAuthenticated = () => (svc.isAuthenticated = !!Object.keys(svc.user).length);

    svc.enableChats = () => {
      return apiService.enableChats();
    };

    svc.addPhone = phoneObj => {
      return svc.getUser().then(user => {
        user.phoneNumbers = user.phoneNumbers || [];
        user.phoneNumbers.unshift({ ...phoneObj });

        return user;
      });
    };

    const loadUser = () => {
      const deferred = $q.defer();

      apiService.getUser().then(
        response => {
          svc.user = response.data.data;

          deferred.resolve(svc.user);
        },
        response => {
          deferred.reject(response);
        },
      );

      return deferred.promise;
    };

    svc.getUser = (needUpdate = false) => {
      const deferred = $q.defer();

      if (!svc.user || needUpdate) {
        loadUser().then(
          response => {
            deferred.resolve(response);
          },
          error => {
            deferred.reject(error);
          },
        );
      } else {
        deferred.resolve(svc.user);
      }

      return deferred.promise;
    };

    svc.setUser = (userData, shouldReloadHeader) => {
      if (userData && userData.userId) {
        if (shouldReloadHeader && angular.isFunction(window.refreshAfterUserLoggedIn)) {
          $timeout(function () {
            window.refreshAfterUserLoggedIn();
          }, 300);
        }
        if (window.Raven) {
          window.Raven.setUserContext({
            email: userData.email,
            id: userData.userId,
          });
        }
      } else {
        if (window.Raven) {
          window.Raven.setUserContext();
        }
      }

      svc.user = userData;
      $rootScope.user = userData;
      setIsAuthenticated();
      $rootScope.$broadcast('user.setUser', userData);
    };

    // можно сделать как промис
    svc.pollTillBalanceUpdate = () => {
      if (!pollingTimeout) {
        const setPollingTimeout = () => {
          const request = () => {
            apiService.getUser().then(
              user => {
                const newUserData = user.data.data;
                if (svc.user.balance !== newUserData.balance) {
                  $timeout.cancel(pollingTimeout);
                  pollingTimeout = null;
                } else {
                  setPollingTimeout();
                }
                svc.user = user.data.data;
              },
              () => {
                // dunno
                setPollingTimeout();
              },
            );
          };
          pollingTimeout = $timeout(request, POLLING_TIMEOUT);
        };
        setPollingTimeout();
      }
    };

    const onUserVerifyPhoneNumberCallbacks = [];

    svc.onUserVerifyPhoneNumber = callback => onUserVerifyPhoneNumberCallbacks.push(callback);

    svc.setUserVerifiedPhoneNumber = () => {
      if (!svc.verifiedPhoneNumberInCurrentSession) {
        svc.verifiedPhoneNumberInCurrentSession = true;
        onUserVerifyPhoneNumberCallbacks.forEach(cb => cb());
      }
    };

    svc.setBalance = value => {
      svc.user.balance = value;

      $rootScope.$broadcast('user.setUser', svc.user);
    };

    const billingPackages = () => get(svc, 'user.billingInfo.packages', []);
    const haveBillingPackage = packageType => some(billingPackages(), ['packageTypeId', packageType.id]);

    svc.isPro = () => haveBillingPackage(PackageTypes.BASE) || haveBillingPackage(PackageTypes.PROFI);
    svc.isAgent = () => !!svc.user.agentAccountType;
    svc.isCommercialOwner = () => ['managementCompany', 'rentDepartment'].includes(svc.user.agentAccountType);

    svc.userExists = () => !!svc.user;

    svc.getUserId = () => {
      if (!svc.userExists()) {
        return null;
      }

      return svc.user.userId;
    };

    return svc;
  },
];
